import { Injectable, NgZone, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent, HttpResponse } from '@angular/common/http';
import { JobsData, Job } from '../Models/job';
import { BehaviorSubject, Observable, Subject, throwError, timer } from 'rxjs';
import { Moment } from 'moment';
import { environment  } from '../../environments/environment';
import { catchError, filter, map, takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { MultiSelectModel, MultiSelect } from '@syncfusion/ej2-angular-dropdowns';
import { IFilterCreate, Column, Filter, GridComponent } from '@syncfusion/ej2-angular-grids';
import { createElement } from '@syncfusion/ej2-base';

@Injectable({
    providedIn: 'root'
})

export class CommonService implements OnInit, OnDestroy {
    headers: any;
    kcLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    activeExportToastId: number | null = null;
    onContactPage = new BehaviorSubject<any>({});
    onContactPage$ = this.onContactPage.asObservable();
    onContactListPage = new BehaviorSubject<any>({});
    onContactListPage$ = this.onContactListPage.asObservable();
    clientTab = new BehaviorSubject<any>('client');
    clientTab$ = this.clientTab.asObservable();
    billingTab = new BehaviorSubject<any>('wip');
    billingTab$ = this.billingTab.asObservable();
    onUserPermission = new BehaviorSubject<any>({});
    onUserPermission$ = this.onUserPermission.asObservable();
    getUserPermission = new BehaviorSubject<any>('roleId');
    getUserPermission$ = this.getUserPermission.asObservable();

    newbillingTab = new BehaviorSubject<any>('general');
    newbillingTab$ = this.newbillingTab.asObservable();
    clientEntityType = new BehaviorSubject<string>('Individual');
    clientEntityType$ = this.clientEntityType.asObservable();
    dataSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    totalLoaderRequests: number = 0;
    private navigationGeneration = 0;
    private navigationCancelSubject = new Subject<number>();
    navigationCancel$ = this.navigationCancelSubject.asObservable();
    connectionAddedSource = new Subject<void>();
    connectionAdded$ = this.connectionAddedSource.asObservable();

    invoiceListSubject = new BehaviorSubject<any>(null);
    invoiceList$ = this.invoiceListSubject.asObservable();

    errorInvoiceSubject = new BehaviorSubject<string | null>(null);
    errorInvoice$ = this.errorInvoiceSubject.asObservable();

    notificationSubject = new BehaviorSubject<any>(null);
    notifications$ = this.notificationSubject.asObservable();

    private spCreateDocEvent = new Subject<void>();
    spCreateDocEvent$ = this.spCreateDocEvent.asObservable();

    private _sharedFolderId = new BehaviorSubject<string | null>(null);
    sharedFolderId$ = this._sharedFolderId.asObservable(); // public Observable

    private _sharedClientId = new BehaviorSubject<number | 0>(null);
    sharedClientId$ = this._sharedClientId.asObservable(); // public Observable

    private unsubscribe$ = new Subject<void>();

    constructor(private http: HttpClient, private ngZone: NgZone, private router: Router, private activatedRoute: ActivatedRoute) {
        const headers: HttpHeaders = new HttpHeaders();
        headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    ngOnInit(): void {

    }

    getBreadcrumbs(): Observable<{ label: string, url: string }[]> {
        return this.router.events.pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {
            let route = this.activatedRoute.root;
            const breadcrumbs: { label: string, url: string }[] = [];
            let url = '';
            while (route.firstChild) {
              route = route.firstChild;
              if (route.snapshot.data['breadcrumb']) {
                url += '/' + route.snapshot.url.map(segment => segment.path).join('/');
                breadcrumbs.push({
                  label: route.snapshot.data['breadcrumb'],
                  url
                });
              }
            }
            return breadcrumbs;
          })
        );
    }

    emitConnectionAdded(): void {
    this.connectionAddedSource.next();
  }

    showLoader(): void {
        this.totalLoaderRequests++;
        this.kcLoader.next(true);
    }

    hideLoader(): void {
        if (this.totalLoaderRequests > 0) {
            this.totalLoaderRequests--;
            if (this.totalLoaderRequests === 0)
                this.kcLoader.next(false);
        }
    }

    startNewNavigation(): number {
      this.navigationGeneration++;
      this.navigationCancelSubject.next(this.navigationGeneration);
      this.totalLoaderRequests = 0;
      this.kcLoader.next(false);
      return this.navigationGeneration;
    }

    completeNavigation(): void {
    }

    getNavigationGeneration(): number {
      return this.navigationGeneration;
    }

    updateNotificationCount(newValue: number): void {
        this.dataSubject.next(newValue);
    }

    /** Creates and returns deep copy of the given object with the same type and without any reference. */
    copyObject<type>(object: type): type {
        return JSON.parse(JSON.stringify(object));
    }

    /** Filters the given `list` for given `search` as per optionally passed `settings` of type `CommonSearchSetting`. */
    filterListForSearchString(list: any[], search: string, settings?: CommonSearchSetting): any[] {
        /* mapping passed setting into default setting */
        settings = this.map_object(new CommonSearchSetting(), settings);

        if ([null, undefined, ''].includes(search)) {
            return list;
        }

        const filteredList = [];
        if (settings.fields.length) {
            list.forEach(item => {
                for (const key of settings.fields) {
                    if (this._match_string(item, key, search)) {
                        filteredList.push(item);
                        break;
                    }
                }
            })
        } else {
            list.forEach(item => {
                for (const key in item) {
                    if (this._match_string(item, key, search)) {
                        filteredList.push(item);
                        break;
                    }
                }
            })
        }
        return filteredList;
    }

    private _match_string(item: any, key: string = '', search: string = ''): boolean {
        let value = item[key];
        if (value) {
            value = typeof value === 'string' ? item[key] : JSON.stringify(item[key]);
            if (value.toLowerCase().includes(search.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    /** Maps all value of `source_object` to `output_object`. */
    map_object(output_object: any, source_object: any) {
        for (const key in source_object) {
            if (source_object[key] instanceof Object && !(source_object[key] instanceof Array)) {
                output_object[key] = this.map_object(output_object[key], source_object[key]);
            } else {
                output_object[key] = source_object[key];
            }
        }

        return output_object;
    }

    /** Returns `true` if both objects are same to the depth else returns `false` */
    compare_objects(objectOne: any, objectTwo: any): boolean {
      return JSON.stringify(objectOne) === JSON.stringify(objectTwo)
    }

    /** Return accepts `Moment` date and javascript `Date` without any timezone. */
    get_date_without_timezone(moment_date: Moment): Date {
        const date = new Date(`${moment_date.year()}-${moment_date.month() + 1}-${moment_date.date()}`)
        return this.get_js_date_without_timezone(date);
    }

    /** Return accepts javascript `Date` and returns without any timezone. */
    get_js_date_without_timezone(date: Date): Date {
        const userTimezoneOffset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - userTimezoneOffset);
    }

    /** Returns javascript `Date` with all time as 0. */
    get_date_without_time(givenDate: any) {
        if (!givenDate) {
            return;
        }
        const date = new Date(new Date(givenDate).toDateString());
        return date;
    }

    /** Returns a `Promise`. Accepts a `condition_callback` pf type `Function`, which will be checked at given `check_interval` time and upon `condition_callback` returning `true`, returned `Promise` will resolve. */
    wait_until_promise(condition_callback: Function, check_interval: number = 500): Promise < void> {
        return new Promise((resolve) => {
            let intervalId: any;
            /* Execute the interval outside Angular's zone to prevent triggering change detection */
            this.ngZone.runOutsideAngular(() => {
                intervalId = setInterval(() => {
                    if (condition_callback()) {
                        clearInterval(intervalId);
                        /* Once the condition is met, run the resolve function inside the Angular zone */
                        this.ngZone.run(() => {
                            resolve();
                        });
                    }
                }, check_interval);
            });
        });
    }

    getStatusOptions() {                     // Dev: Naveen, Date:06/05/2024, Cust-4080
        return [
            { id: 2, name: "Published" },
            { id: 3, name: "Reviewed" },
            { id: 5, name: "Rejected" },
            { id: 4, name: "Approved" },
        ];
    }

    getInvoiceList(): void {
        if (!this.invoiceListSubject.getValue()) {
            this.http.get<any>('Billing/GetInvoiceList').pipe(
              tap(invoices => this.invoiceListSubject.next(invoices),
              catchError(error => {
                this.errorInvoiceSubject.next(error.message);
                return throwError(error);
              }))
            ).subscribe();
        }
    }

    getDocDetails(doc) {       //CUST-4782, Sachin Yadav, 06-Feb-2025
        return this.http.get<any>('Document/GetFileFromBlob?docUrl=' + doc, { headers: this.headers })
    }

    getAllInvoices(clientId?: any, invoiceId?: any){
        if (clientId != null && invoiceId != null) {
            return this.http.get<any>(`Billing/GetInvoiceListNewByClientIdInvoiceId?clientId=${clientId}&invoiceId=${invoiceId}`, { headers: this.headers});
        }
        return this.http.get<any>('Billing/GetInvoiceListNew', { headers: this.headers});
    }
    getAllInvoiceList(): void {
        if (!this.invoiceListSubject.getValue()) {
            this.http.get<any>('Billing/GetInvoiceListNew').pipe(
              tap(invoices => this.invoiceListSubject.next(invoices),
              catchError(error => {
                this.errorInvoiceSubject.next(error.message);
                return throwError(error);
              }))
            ).subscribe();
        }
    }

    invalidateInvoiceList(): void {
        this.invoiceListSubject.next(null);
    }

    getInvoiceDraftNumber() {
        return this.http.get<any>('Billing/GetInvoiceDraftNo', { headers: this.headers});
    }

    downloadDocument(documentId: string, isVersion: boolean): Observable<HttpEvent<Blob>> {
        const url = `${environment.dmsBasePath}document/${documentId}/downloadDocument`;
        return this.http.get(url, {
          reportProgress: true,
          observe: 'events',
          responseType: 'blob',
        });
    }

    checkMSO365connectivity() {
        return this.http.get<any>('Mail/GetMail', { headers: this.headers});
    }

    generateAuthUrl() {
        return this.http.get<any>('Mail/AuthenticationUrl', { headers: this.headers});
    }

    getDocumentLinkById(documentId: string) {
        return this.http.get<any>('Communication/GetSPDocDetails?documentId=' + documentId);
    }

    downloadSharepointFile(fileUrl: string) {
        return this.http.get(fileUrl, { responseType: 'blob' });
    }

    downloadSPFile(driveId: string, driveItemId: string) {
        const url = `Communication/DownloadSPDocument/${driveId}/${driveItemId}`;
        return this.http.get(url, { responseType: 'blob'});
    }

    sendEmail(formData) {
        return this.http.post<any>('Mail/SendMail', formData, { headers: this.headers});
    }

    sendInvoice(formData) {
        return this.http.post<any>('Mail/SendInvoice', formData, { headers: this.headers })
    }

    focus_invalid_form_field(form: FormGroup, element: ElementRef, validateDirection: 'top-left' = 'top-left') {
        const invalidControls = []
        for (const key of Object.keys(form.controls)) {
            if (form.controls[key].invalid) {
                const invalidElement = element.nativeElement.querySelector('[name="' + key + '"]');
                if (invalidElement) {
                    let input = invalidElement;
                    /* ng-select focus */
                    if (invalidElement.tagName === 'NG-SELECT') {
                        const inputs = invalidElement.querySelectorAll('input');;
                        input = inputs[0];
                    };

                    if(input && !input?.disabled && !input?.readOnly){
                        invalidControls.push(input);
                    }

                }
            }
        }

        /* sorting all invalid fields as top to bottom and left to right */
        if(validateDirection === 'top-left'){
            invalidControls.sort((a, b) => {
                const _a = a.getBoundingClientRect();
                const _b = b.getBoundingClientRect();

                if (_a.y === _b.y) {
                    return _a.x - _b.x;
                }
                return _a.y - _b.y;
            });
        }

        if(invalidControls.length){
            invalidControls[0].focus();
        }
    }

    get_unique_id(){
        return crypto.randomUUID();
    };

    /** returns address in the multiline format with «new_line_placeholder» as a placeholder for new line */
    get_address_for_template(address: AddressTemplateDetails){
        for (const key in address) {
            address[key] = address[key]?.trim() ?? null;
        };
        /** return empty if any mandatory field is not there */
        if([address.AddressLine1, address.Suburb, address.State, address.Postcode].some(x => !x)){
            return '';
        }

        const unit = [null, undefined, 'null', 'undefined', ''].includes(address.Unit) ? '' : address.Unit;
        const country = address.Country === 'Australia' ? '' : address.Country;

        const address_string = [unit, address.AddressLine1, address.AddressLine2, `${address.Suburb} ${address.State} ${address.Postcode}`, country].filter(x => x).join('«new_line_placeholder»')
        return address_string;
    }

    /** accepts `date` as valid 'DD/MM/YYYY' and returns valid Date without any time. */
    getDateFromDDMMYY(date: string /* DD/MM/YYYY */) {
        if (!date) {
            return;
        }
        if (moment.isMoment(date)) {
        return this.get_date_without_time(date.toDate());
    }
        return this.get_date_without_time(date.split('/').reverse().join('-'));
    }

    /** Accepts `amount` and if it is valid and has value – then returns it formatted as `$(1,234)` for negative and as `$1,234` for positive values, else returns default value or null. */
    formatChartAmount(amount: any, toDecimals: number = 0){
        const parsedAmount = +amount;

        if(!isNaN(parsedAmount) && ![undefined, null].includes(amount)){
            let formattedAmount = parsedAmount.toFixed(toDecimals)?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? amount;
            if(parsedAmount < 0){
                /* if negative amount then remove '-' and wrap in '()' */
                formattedAmount = `(${formattedAmount.replace('-', '')})`;
            }
            return `$${formattedAmount}`;
        }

        return (amount ?? null);
    }

    getValidFormatNarration(string: any) {
        if(!string){
            return string;
        }

        /* updating font styling properties & attributes, so that only default size & styles are applied */
        const newString = string
            /* replace property "font-family" with "font-family-kcNotAllowed" */
            .replace(/font-family/g,'font-family-kcNotAllowed')
            /* replace property "font-size" with "font-size-kcNotAllowed" */
            .replace(/font-size/g, 'font-size-kcNotAllowed')
            /* replace property "<font face=" with "<font face-kcNotAllowed=" */
            .replace(/(<font[^>]*?)face=([^>]*>)/g, '$1face-kcNotAllowed=$2')
            /* replace property "<font size=" with "<font size-kcNotAllowed=" */
            .replace(/(<font[^>]*?)size=([^>]*>)/g, '$1size-kcNotAllowed=$2')

        return newString;
    }

    getFormattedJobName(jobDetail: {jobName: string, financialYear: string, period?: string}){
        const formattedJobName = [(jobDetail.jobName ?? '').trim(), (jobDetail.financialYear ?? '').trim(), (jobDetail.period ?? '').trim()].filter(x => x).join(' ');
        return formattedJobName;
    }

    DownloadInvoice(invoiceId: number, templateId: number): Observable<HttpResponse<Blob>> {
        return this.http.get('Billing/DownloadInvoice?invoiceId=' + invoiceId + '&templateId=' + templateId, { responseType: 'blob', observe: 'response' });
    }

    /** Validates `paste` event the content of pasting to be numbers only. */
    validatePasteNumbers(event: ClipboardEvent) {
        event.preventDefault();
        if (event.clipboardData) {
            /* get pasted data as text */
            const pastedInput: string = event.clipboardData.getData("text/plain");
            /* remove non-numeric characters */
            let transformedInput = pastedInput.replace(/[^0-9-]|(?!^)-/g, "");
            /* insert modified text */
            document.execCommand("insertText", false, transformedInput);
        }
    }

    /** Validates `keyPress` event to allow typing numbers only. */
    validateKeyPressNumbers(event: KeyboardEvent, allowNegative: boolean = true): boolean {
        /* Allow control keys (backspace, delete, arrow keys, etc.) */
        if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            return true;
        } else if (!(/[.\-\d]/.test(event.key))) {
            /* if not '-' or '.' or number, return false */
            return false;
        }

        const target = event.target as HTMLInputElement;
        let currentValue = target.value ?? '';
        const cursorPosition = target.selectionStart ?? 0
        const selectionEnd = target.selectionEnd ?? 0;

        /* if select all is done then 'just the current character' else 'create new value to be with the added character' */
        currentValue = currentValue.replace(/,/g, '');
        let newValueTobe = (currentValue?.length && selectionEnd !== cursorPosition && (selectionEnd === (currentValue?.length ?? 0))) ? event.key : `${(currentValue.slice(0, cursorPosition) ?? '')}${event.key}${(currentValue.slice(cursorPosition) ?? '')}`;

        /* test regex for positive/negative numbers up to 2 decimals */
        const regex = allowNegative ? /^-{0,1}?\d*(\.\d{0,2})?$/ : /^\d*(\.\d{0,2})?$/;

        if (!regex.test(newValueTobe)) {
            event.preventDefault();
            return false;
        }

        return true;
    }

    debounce(callback: Function, delay: number = 300) {

        timer(delay).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            callback();
        });
  };

    validateUserList(
    userList: any[],
    savedUserIds: string[] = [],
    {
      userIdKey = 'userId',
      statusKey = 'inviteStatus',
      isEditMode = false
    }: {
      userIdKey?: string;
      statusKey?: string;
      isEditMode?: boolean;
    } = {}
  ) {
    return userList?.filter(user => {
      const isRevoked = user[statusKey] === 'Revoked';                            //Developer: Sasmit, Ticket: CUST-11033, Date: 27-May-2026

      // If revoked, only show if in edit mode AND previously saved
      if (isRevoked) {
        return isEditMode && savedUserIds?.includes(user[userIdKey]);
      }

      // Show all non-revoked users in both modes
      return true;
    }) ?? [];
  }

  /** Returns custom column filter for `ejs-grid` of type `Menu` with MultiSelect dropdown for comma separated value columns. */
    getArrayColumnFilter(dropdown: MultiSelectModel, customFilterdropdownRef: MultiSelect, grid: () => GridComponent, FilterByValues: () => {field: string, filterValue: any, predicate: string, operator: string}[]) {
        const valueDropdownDisabledOperators = ['isempty', 'isnotempty'];

        const validateValuesForOperator = (operatorInst) => {
            if (valueDropdownDisabledOperators.includes(operatorInst.value)) {
                /* clear the selected values upon selection of these operators */
                customFilterdropdownRef.clear();
                customFilterdropdownRef.enabled = false;
            } else {
                customFilterdropdownRef.enabled = true;
            }
        }

        return {
            type: 'Menu',
            ui: {
                create: (args: IFilterCreate) => {
                    const input: HTMLElement = createElement('input', {className: 'flm-input'});
                    args.target.appendChild(input);
                    let operatorInst = (args.dialogObj.element.querySelector('input') as any)?.ej2_instances[0];

                    customFilterdropdownRef = new MultiSelect({
                        ...dropdown,
                        created: () => {
                            if(operatorInst){
                                const isContainsWithOr = FilterByValues().filter(f => f.field === args.column.field && f.operator === 'contains')?.some(f => f.predicate === 'or');

                                /* selecting custom operator 'contains_or' if any fiter is "contains + or" */
                                operatorInst.value = (operatorInst.value == 'contains' && isContainsWithOr) ? 'contains_or' : operatorInst.value;
                            }
                            validateValuesForOperator(operatorInst);
                        }
                    });
                    customFilterdropdownRef.appendTo(input);

                    if (operatorInst) {
                        operatorInst.change = (args) => {
                            validateValuesForOperator(operatorInst);
                        };
                    }
                },
                write: (args: any) => {
                    if (args.filteredValue && args.filteredValue.length > 0) {
                        (customFilterdropdownRef as MultiSelect).value = FilterByValues().filter(f => f.field === args.column.field).map(f => f.filterValue);
                    }
                },
                read: (args: {
                    column: Column;
                    operator: string;
                    fltrObj: Filter;
                }) => {
                    grid()?.removeFilteredColsByField(args.column.field);
                    const selectedValues = (customFilterdropdownRef as MultiSelect).value;
                    const filteredValues = Array.isArray(selectedValues) ? selectedValues.map(item => typeof item === 'object' ? (item as any).id : item) : [];
                    // Ensure selectedValues is an array
                    if (filteredValues?.length > 0) {
                        args.fltrObj.filterByColumn(
                            args.column.field,
                            /* make 'contains_or' as 'contains' only for the grid */
                            args.operator === 'contains_or' ? 'contains' : args.operator,
                            filteredValues,
                            ['contains', 'notequal', 'contains'].includes(args.operator) ? 'and' : 'or'
                        );
                    } else if (['isempty', 'isnotempty'].includes(args.operator)) {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, ['', null, undefined], 'or');
                    }
                },
            },
        };
    }

    /**
     * Applying the 'notequal' filter operator with no value typed in reaches the backend
     * as `field <> NULL` - SQL's three-valued logic never evaluates a NULL comparison as
     * true for any row, so the whole result set comes back empty regardless of what other
     * filters are set. Callers should cancel the grid's filtering actionBegin event and
     * surface the returned message when this reports blocked: true.
     */
    guardEmptyNotEqualFilter(args: any): { blocked: boolean; message?: string } {
        if (args?.requestType !== 'filtering') return { blocked: false };

        const filterObj = args.currentFilterObject;
        const operator = String(filterObj?.operator || '').toLowerCase();
        if (operator !== 'notequal') return { blocked: false };

        const value = filterObj?.value;
        const isBlank = value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
        if (!isBlank) return { blocked: false };

        return {
            blocked: true,
            message: `Enter a value to use "Not equal", or choose "Is not empty" to filter for blank ${filterObj?.field || ''} values.`
        };
    }

    triggerSPCreateDocEvent() {
        this.spCreateDocEvent.next();
    }

    get currentFolderId(): string | null {
        return this._sharedFolderId.value;
    }
    get currentClientId(): number | 0 {
        return this._sharedClientId.value;
    }
    // updating methods
    updateFolderId(folderId: string | null) {
        this._sharedFolderId.next(folderId);
    }
    updateClientId(clientId: number | 0) {
        this._sharedClientId.next(clientId);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    sumArrayByKey(array: any[], key: string): number {
        if (!array || !array.length) 
            return 0;

        const sum = array.reduce((sum, item) => sum + (isNaN(+item[key]) ? 0 : +item[key]), 0);
        return sum;
    }

    private suppressGlobalLoaderCount: number = 0;
    globalLoaderSuppressed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    suppressGlobalLoader(): void {
        this.suppressGlobalLoaderCount++;
        this.globalLoaderSuppressed.next(true);
    }

    allowGlobalLoader(): void {
        if (this.suppressGlobalLoaderCount > 0) {
            this.suppressGlobalLoaderCount--;
        }
        if (this.suppressGlobalLoaderCount === 0) {
            this.globalLoaderSuppressed.next(false);
        }
    }
}


// #Jobregion
@Injectable({
    providedIn: 'root'
})
export class JobService {
    public jobData: any = new JobsData();
    public job = new Job();
}


// #EndRegion

class CommonSearchSetting {
    /** fields in the object to perform search on. */
    fields: string[] = [];
    /** type of search operation `contains` | `exact`, @default 'contains'. */
    search_type?: 'contains' | 'exact' = 'contains';
    /** is search case sensitive or not, @default false. */
    is_case_sensitive?: boolean = false;
}

class AddressTemplateDetails {
    Unit: string = null;
    AddressLine1: string = null;
    AddressLine2?: string = null;
    Suburb: string = null;
    State: string = null;
    Country?: string = null;
    Postcode: string = null;
}
